import { ComponentType } from "@grafikr/components";
import fastdom from "fastdom";
import Cart from "utils/cart";
import Algolia from "utils/algolia";
import LineItem from "@grafikr/shopify-typescript/type/LineItem";
import klaviyoAtc from 'utils/klaviyo-atc';

const Component: ComponentType = (node: HTMLFormElement, { emitter }) => {
  const form: HTMLFormElement = node.querySelector("form[action=\"/cart/add\"]");
  const atcButton = form.querySelector("[data-atc]");
  const queryID = new URLSearchParams(window.location.search)?.get("queryID") ?? null;
  const error = form.querySelector<HTMLElement>("[data-error]");
  const client = new Algolia();

  const handleSubmit = async () => {
    const formData = new FormData(form);
    const productsToAdd: { items: { id: number; quantity: number; properties?: any }[] } = {
      items: []
    };

    const selectId: HTMLSelectElement = form.querySelector("select[name=\"id\"]");
    const bulkAddButtons = form.parentElement.parentElement.querySelectorAll("[data-bulk-add]");
    const stickyAdd = document.querySelector(".product__sticky-add");
    const stickyAddBulkButtons = stickyAdd?.querySelectorAll("[data-bulk-add]");
    const activeBulkAdds = [...bulkAddButtons, ...stickyAddBulkButtons]
      .filter((button) => button.classList.contains("done"))
      .map((i) => {
        const id = +i.parentElement.parentElement.querySelector<HTMLSelectElement>("select").value;
        const compareAt =
          i.parentElement.parentElement.querySelector<HTMLSelectElement>(`option[value="${id}"]`)
            ?.dataset?.compare || "0";
        return { id, compareAt };
      });

    const atcModal: HTMLElement = document.querySelector("[data-component=\"add-to-cart-modal\"]");
    const comparePrice =
      selectId.querySelector<HTMLSelectElement>(`option[value="${selectId.value}"]`)?.dataset
        ?.compare || "0";


    const obj = {
      id: +formData.get('id'),
      quantity: 1,
      selling_plan: +formData.get('selling_plan'),
      properties: { _comparePrice: comparePrice }
    };

    if (!formData.get('selling_plan')) {
      delete obj.selling_plan;
    }

    productsToAdd.items.push(obj);
    activeBulkAdds.forEach(({ id, compareAt }) => {
      productsToAdd.items.push({
        id: +id,
        quantity: 1,
        properties: { _comparePrice: compareAt }
      });
    });

    Cart.addMultiple(productsToAdd, {
      success: async (body: { items: LineItem[] }) => {
        fastdom.mutate(() => {
          error.hidden = true;
        });

        client.track("convertedObjectIDs", {
          index: "products",
          eventName: "Product Added",
          objectIds: body.items.map((i) => i.product_id.toString()),
          queryID
        });

        klaviyoAtc(formData.get('handle').toString());

        if (activeBulkAdds.length) {
          if (activeBulkAdds.length < bulkAddButtons.length) {
            atcModal.dataset.ids = body.items
              .filter(
                (i) =>
                  activeBulkAdds.map((item) => item.id).includes(i.variant_id) ||
                  i.variant_id === +selectId.value
              )
              .map((i) => i.variant_id.toString())
              .join(",");

            emitter.emit("product:added");
          } else {
            atcModal.dataset.ids = "";
            emitter.emit("cart:open");
          }
        } else {
          atcModal.dataset.ids = body.items[0].variant_id.toString();
        }

        emitter.emit("cart:added");
      },
      error: (body) => {
        fastdom.mutate(() => {
          error.hidden = false;
          error.textContent = `${body.message} - ${body.description}`;
        });

        emitter.emit("cart:error", body);
      }
    });
  };

  atcButton.addEventListener("click", handleSubmit);
};

export default Component;
